import { localized, msg } from "@lit/localize";
import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "@whilecat/core/loaders/loading-icon.js";
import "@whilecat/core/elements/errors/error-element.ts";

@localized()
@customElement("loading-element")
export class LoadingElement extends LitElement {
    static styles = css`
      :host {
        display: flex;
        justify-content: center;
        text-align: center;
        color: var(--whilecat-primary);
        font-size: 20px;
      }

      #loading {
        font-size: 40px;
        padding: 20px;
      }
    `;

    @property({ type: Boolean }) failed = false;

    render() {
        if (this.failed) {
            return html`<error-element></error-element>`;
        }
        return html`
          <div>
              ${msg("Loading")}
            <loading-icon id="loading"></loading-icon>
          </div>
        `;
    }
}
